var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 15 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.919 4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m3.135 9.5H.784a7.5 7.5 0 0 1 6.634-4 7.5 7.5 0 0 1 6.636 4"
})));
export default SvgAccountMenu;